import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/srv-services/my-account/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountServiceDetailInput = paths[url]['get']['parameters']['path'];
export type GetMyAccountServiceDetailSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

/**
 * Requests endpoint to get a store's worker.
 */
export const useGetMyAccountServicesDetail = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setMyAccountServiceDetail, setIsLoadingMyAccountServiceDetail } = useData();

    const request = async (props: GetMyAccountServiceDetailInput) => {
        setIsLoadingMyAccountServiceDetail(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error: any) {
                    error.message = '';
                }

                error.statusCode = response.status;

                throw error;
            }

            const data: GetMyAccountServiceDetailSuccessResponse = await response.json();

            setMyAccountServiceDetail(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setIsLoadingMyAccountServiceDetail(false);
        }
    };

    return { request };
};
